import './metrics.css';

export  const Metrics = (props) => {
    return(
        <div className='metrics'>
            <h4 className='metrics-number'>{props.metric? props.metric:'00'}</h4>
            <h5 className='metrics-subtitle'>{props.title? props.title:'Subtítulo'}</h5>
            <p className='metrics-descriptive'>{props.description? props.description:'Texto descriptivo'}</p>
        </div>
    )
}
